/**
 * ReplyIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const ReplyIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M20.91 19.6q-.466 0-.777-.312a1.06 1.06 0 0 1-.312-.778v-3.96q0-1.392-.967-2.351t-2.344-.96H5.707l3.234 3.234a.98.98 0 0 1 .29.737 1.1 1.1 0 0 1-.317.764 1.06 1.06 0 0 1-.772.325q-.447 0-.772-.325l-5.06-5.06a1 1 0 0 1-.24-.36A1.2 1.2 0 0 1 2 10.15q0-.212.07-.404a1 1 0 0 1 .24-.36l5.088-5.088A1 1 0 0 1 8.142 4q.447 0 .772.325.325.326.325.764 0 .44-.325.764L5.707 9.06H16.51q2.27 0 3.88 1.597T22 14.55v3.96q0 .466-.311.778a1.06 1.06 0 0 1-.778.312" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const ReplyIcon = makeIcon('ReplyIcon', ReplyIconSvg)
